module.exports = __webpack_public_path__ + "static/img/DSC_0361.2ee525b.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/DSC_0361.jpeg
// module id = 129
// module chunks = 1